"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Select = styled_components_1.default.select `
  align-items: center;
  background: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: 0;
  color: ${({ theme }) => theme.colors.greyLighten70};
  display: flex;
  font-size: 1rem;
  font-weight: normal;
  justify-content: center;
  padding: ${({ theme }) => `${theme.spacings.xs} 2rem ${theme.spacings.xs}  ${theme.spacings.m}`};
  text-overflow: ellipsis;
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &:not([multiple]):not(:disabled):checked,
  &:not([multiple]):not(:disabled):focus,
  &:not([multiple]):not(:disabled):hover {
    color: ${({ theme }) => theme.colors.greyBase};
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background: ${({ theme }) => theme.colors.silverBase};
  }

  &[multiple] {
    padding: ${({ theme }) => theme.spacings.xs};
    option {
      padding: ${({ theme }) => theme.spacings.xs};
    }
    &:not(:disabled) {
      option:checked,
      option:hover {
        color: ${({ theme }) => theme.colors.greyLighten70};
      }
    }
  }

  &[data-selected="true"] {
    color: ${({ theme }) => theme.colors.greyBase};
  }
`;
//# sourceMappingURL=select.js.map